import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { schema as base } from '../lookbook-banner/lookbook-banner.schema'

const GALLERY_FIELD: FieldSchema = {
  key: 'gallery',
  label: 'Mosaic pictures',
  type: 'array',
  help: 'Up to two (split) or three (full width) extra pictures shown as a mosaic with the main picture.',
  itemSchema: [
    { key: 'image', label: 'Picture', type: 'image' },
    { key: 'alt', label: 'Description (alt text)', type: 'string' },
    { key: 'link', label: 'Link', type: 'string' },
  ],
}

/** Mohalla lookbook: the base variants plus optional mosaic pictures. */
export const schema: ComponentSchema = {
  ...base,
  variants: base.variants.map(v => ({ ...v, fields: [...(v.fields ?? []), GALLERY_FIELD] })),
}
